import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import rolePermissionService from '../../../services/roles&permission.service';

const initialState = {
  listRole: [],
  loading: false,
  error: null,
  listPermission: [],
  listPermissions: [],
  roleDetail: null,
};

export const getListRoles = createAsyncThunk('roles&permisson/list', async () => {
  const response = await rolePermissionService.getListRoles();
  return response;
});

export const getListPermission = createAsyncThunk('roles&permisson/getListPermission', async () => {
  const response = await rolePermissionService.getListPermission();
  return response;
});

export const getListPermissions = createAsyncThunk(
  'roles&permisson/getListPermissions',
  async () => {
    const response = await rolePermissionService.getListPermissions();
    return response;
  },
);

export const searchListPermissions = createAsyncThunk(
  'roles&permisson/searchListPermissions',
  async (name) => {
    const response = await rolePermissionService.searchListPermission(name);
    return response;
  },
);

export const createRole = createAsyncThunk(
  'roles&permisson/createRole',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await rolePermissionService.createRole(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const editRole = createAsyncThunk(
  'roles&permisson/editRole',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await rolePermissionService.editRole(payload.id, payload.payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getRolebyID = createAsyncThunk(
  'roles&permisson/getRolebyID',
  async (id, { rejectWithValue }) => {
    try {
      const response = await rolePermissionService.getRolebyID(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const userManagementSlice = createSlice({
  name: 'rolePermission',
  initialState,

  extraReducers: (builder) => {
    // list user
    builder.addCase(getListRoles.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListRoles.fulfilled, (state, action) => {
      const output = action.payload.data.map((s) => {
        if (s.hasOwnProperty('name')) {
          s.title = s.name;
          delete s.name;
        }
        if (s.hasOwnProperty('id')) {
          s.key = s.id;
          delete s.id;
        }
        s.width = 200;
        return s;
      });
      const columnsTable = [
        {
          title: 'Permission',
          dataIndex: 'name',
          key: 'name',
          width: 250,
          fixed: 'left',
        },
        ...output,
      ];
      state.listRole = columnsTable;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getListRoles.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    // user detail
    builder.addCase(getListPermission.pending, (state) => {
      state.loadingDetail = true;
    });
    builder.addCase(getListPermission.fulfilled, (state, action) => {
      const { permissionGroupDtos } = action.payload;

      const newArray = permissionGroupDtos.map((item) => {
        if (item.hasOwnProperty('permissionDto')) {
          item.children = item.permissionDto;
          delete item.permissionDto;
        }
        if (item.hasOwnProperty('id')) {
          item.key = item.id;
          delete item.id;
        }
        return item;
      });
      const appendColumn = [
        {
          key: 1,
          name: 'Status',
        },
        {
          key: 2,
          name: 'Action',
        },
        ...newArray,
      ];
      state.listPermission = appendColumn;
      state.loadingDetail = false;
      state.error = null;
    });
    builder.addCase(getListPermission.rejected, (state, action) => {
      state.error = action.payload;
      state.loadingDetail = false;
    });
    builder.addCase(searchListPermissions.pending, (state) => {
      state.loadingDetail = true;
    });
    builder.addCase(searchListPermissions.fulfilled, (state, action) => {
      const { permissionGroupDtos } = action.payload;

      const newArray = permissionGroupDtos.map((item) => {
        if (item.hasOwnProperty('permissionDto')) {
          item.children = item.permissionDto;
          delete item.permissionDto;
        }
        if (item.hasOwnProperty('id')) {
          item.key = item.id;
          delete item.id;
        }
        return item;
      });
      const appendColumn = [
        {
          key: 1,
          name: 'Status',
        },
        {
          key: 2,
          name: 'Action',
        },
        ...newArray,
      ];
      state.listPermission = appendColumn;
      state.loadingDetail = false;
      state.error = null;
    });
    builder.addCase(searchListPermissions.rejected, (state, action) => {
      state.error = action.payload;
      state.loadingDetail = false;
    });
    builder.addCase(getListPermissions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getListPermissions.fulfilled, (state, action) => {
      state.listPermissions = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getListPermissions.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(createRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createRole.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(createRole.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(editRole.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editRole.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(editRole.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
    builder.addCase(getRolebyID.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRolebyID.fulfilled, (state, action) => {
      state.roleDetail = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getRolebyID.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
    });
  },
});

export const {
  setIsCreatingUser,
  setIsEdittingUser,
  setIsCreatingRole,
  cleanUpState,
  setIsSelectedProduct,
} = userManagementSlice.actions;
export default userManagementSlice.reducer;
